// extracted by mini-css-extract-plugin
export default {"btn__scroll_top":"BtnUp_btn__scroll_top__TeFRl","visible":"BtnUp_visible__MaEG+"};